import { Injectable } from '@angular/core';
import { HttpErrorsService } from '../alerts/errors/http-errors.service';
import { ConectarApiService } from '../api/connection/conectar-api.service';


@Injectable({
  providedIn: 'root'
})
export class GlobalServicCentros {
  tipoCentros: any;
  centrosasociados: any;

  constructor(private servicioAPI: ConectarApiService,private httpErrorService: HttpErrorsService) { }

/*     settipoCentros (tc) {
      this.tipoCentros = tc;
      this.centrosasociados = tc;
    }
 */
  async getCentros(){
    const cached = localStorage.getItem("CentrosIds");
    const parsed = cached ? (() => { try { return JSON.parse(cached); } catch { return null; } })() : null;
    const isListaObjetos = parsed && Array.isArray(parsed) && parsed.length > 0 &&
      (typeof parsed[0] === "object" && parsed[0] !== null && (parsed[0].Nombre != null || parsed[0].pkId != null || parsed[0].Id != null));
    if (isListaObjetos) {
      this.tipoCentros = parsed;
      this.centrosasociados = this.tipoCentros;
    } else {
      await this.servicioAPI.getCentrosAsync().then(data => {
        let CentrosAPI = data;
        this.tipoCentros = [];
        const lista = CentrosAPI?.DatosResult?.ListaCentros ?? CentrosAPI?.DatosResult?.Lista ?? null;
        if (lista != null && Array.isArray(lista)) {
          this.tipoCentros = lista;
          this.centrosasociados = this.tipoCentros;
        }
      },
        error => { this.httpErrorService.identificarErrores(error); }
      );
    }
  }
/*     setcentrosasociados(sa) {
      this.centrosasociados = sa;
    } */

    //centros
    filtrarTiposCentros() {
      // return this.tipoCentros.filter(x => x.Activo == "True");
      let respuesta = [];
      let Centros = []
      if (this.tipoCentros) Centros = this.tipoCentros.filter(x => x.Activo == "True");
      let tmpCentrosAsociados = this.tipoCentros;
      if (Centros != null && Centros.length > 0) {
        respuesta = Centros.filter(function (item) {
          return tmpCentrosAsociados.findIndex(function (itemSub) { return itemSub == item.pkId }) === -1;
        });
      }
      else {
        if (this.tipoCentros) respuesta = this.tipoCentros.filter(x => x.Activo == "True");
      }
      return respuesta;
    }
  
    comparaObjetosSelect(o1: any, o2: any) {
      return o1 && o2 ? o1.id === o2.id || o1 === o2.id || o1.id === o2 : o1 === o2;
    }
    asignarTipoCentro(item, evento) {
      this.centrosasociados.push(item.pkId);
    }
    desasignarTipoCentro(item, evento) {
      let arrtemp = [];
      arrtemp = this.centrosasociados.filter(function (x) { return x != item.pkId });
      this.centrosasociados = arrtemp;
  
    }
  
    deasignarTodosCentros() {
      this.centrosasociados = [];
    }
    asignarTodosCentros() {
      this.centrosasociados = this.tipoCentros.filter(x => x.Activo == "True").map(function (x) { return x.pkId });
    }
  
    obtenercentrosAsociadosconOrden(centrosAsignados): string {
      // O customan-dual-list (angular-dual-listbox) pode devolver itens no formato BasicList:
      // { _id, _name, ... } em vez de { pkId, Nombre }.
      // Então normalizamos para obter o ID corretamente.
      if (!centrosAsignados || !Array.isArray(centrosAsignados) || centrosAsignados.length === 0) {
        return "";
      }

      const ids = centrosAsignados
        .map((centro: any) => {
          if (centro == null) return null;
          // item primitivo (string/number)
          if (typeof centro === "string" || typeof centro === "number") return String(centro).trim();
          // formatos comuns: pkId (API), _id (DualList), id (alguns modelos)
          const raw = centro.pkId ?? centro._id ?? centro.id ?? centro.PkId ?? centro.pkid ?? centro.CentroId ?? centro.Id;
          if (raw == null) return null;
          const s = String(raw).trim();
          return s.length ? s : null;
        })
        .filter((x: string | null): x is string => !!x);

      // Remove duplicados preservando ordem
      const seen = new Set<string>();
      const uniq = ids.filter((id) => {
        if (seen.has(id)) return false;
        seen.add(id);
        return true;
      });

      return uniq.join(",");
    }

    private _getIdCentro(centro: any): string | null {
      if (!centro || typeof centro !== "object") return null;
      const raw = centro.pkId ?? centro.PkId ?? centro.Id ?? centro.id ?? centro.CentroId ?? centro.pkid;
      if (raw == null) return null;
      const s = String(raw).trim();
      return s.length ? s : null;
    }

    daTiposCentros(registroComponente): any[] {
      let respuesta = [];
      const centrosIdsStr = registroComponente?.CentrosIds ?? registroComponente?.centrosIds ?? "";
      if (!centrosIdsStr || typeof centrosIdsStr !== "string") return respuesta;

      const arrayCentrosString = centrosIdsStr.split(",")
        .map((id: any) => (id != null ? String(id).trim() : ""))
        .filter((id: string) => id.length > 0);

      if (arrayCentrosString.length === 0) return respuesta;

      const allCentros = (this.tipoCentros && Array.isArray(this.tipoCentros))
        ? this.tipoCentros.filter((x: any) => !x || x.Activo == "True" || x.Activo === true)
        : [];

      arrayCentrosString.forEach((centropkId: string) => {
        const act = allCentros.find((find: any) => this._getIdCentro(find) === centropkId);
        if (act) {
          respuesta.push(act);
        } else {
          respuesta.push({ pkId: centropkId, Nombre: "Centro " + centropkId });
        }
      });

      return respuesta;
    }

    //centros

}
